module.exports = __webpack_public_path__ + "static/media/Png.2c7699e3.png";